// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItemModal-cls1___de56a811af60b1cd3a0{/*!*/}.CreateSocialItemModal-cls2__ac93d7121a207f27dd97{display:flex;flex-direction:column;overflow-y:auto;border-bottom:1px solid #dddde2;border-bottom:1px solid var(--stroke-light, #dddde2);padding-bottom:24px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItemModal-cls1___de56a811af60b1cd3a0",
	"cls2": "CreateSocialItemModal-cls2__ac93d7121a207f27dd97 CreateSocialItemModal-cls1___de56a811af60b1cd3a0"
};
export default ___CSS_LOADER_EXPORT___;
